import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';

import { MatCard, MatCardContent } from '@angular/material/card';

import { Subject } from 'rxjs';

import { AccountData } from '@common/data';
import { NavService } from '@common/services';

import { TasksComponent as TasksComponent_1 } from '../../../../libs/tasks/components/tasks/tasks.component';


@Component({
    templateUrl: './tasks.component.html',
    styleUrls: ['./tasks.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatCard,
        MatCardContent,
        TasksComponent_1,
    ]
})
export class TasksComponent implements OnInit, OnDestroy {
  private _navService = inject(NavService);
  private _accountData = inject(AccountData);


  private _destroy$ = new Subject<void>();

  public ngOnInit(): void {
    this._setTitle();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public drawerOpened(task): void {
    this._accountData.projectRecent(task.projectId)
      .subscribe();
  }

  private _setTitle(): void {
    this._navService.setTitle('Tasks', '', '');
  }

}
